
/*
 * Simple struct to create alerts easily.
 *
 * General usage pattern is:
 *  const alert = new Alert("LifeAlert", "Help! I've fallen and I can't get up!", "alert");
 *  appStore.addAlert(alert);
*/

class Alert {

    constructor(title = "", text = "", type = "", value=false) {
        this.title = title;
        this.text = text;
        this.type = type;
        this.value = value;
    }

}

export { Alert };